/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import React from "react";
import { useSelector } from "react-redux";
import { setScheduledTask } from "../../../store/api/tasks/reducer";
import { tasksSelector } from "../../../store/api/tasks/selector";
import { setErrorMsg } from "../../../store/helpers/helperReducers";
import { errorMsgSelector } from "../../../store/helpers/helperSelectors";
import { useStoreDispatch } from "../../../store/hooks";
import { exportDMFormat } from "../../../globals/constants";
import { RadixSelectControl } from "../../ui/radix-select";
import { Label } from "../../ui/label";
import { InputField } from "../../Shared/Radix/Inputs/InputField";

export const ExportSnDataModel = () => {
    const dispatch = useStoreDispatch();
    const errorMsg = useSelector(errorMsgSelector);
    const scheduledtasks = useSelector(tasksSelector);

    const selectChangeHandler = (value: string) => {
        dispatch(setScheduledTask({ outputFormat: value }));
        dispatch(setErrorMsg({ ...errorMsg, outputFormat: "" }));
    };

    const onInputChange = (name: string, value: string) => {
        dispatch(setScheduledTask({ [name]: value }));
        dispatch(setErrorMsg({ ...errorMsg, [name]: "" }));
    };

    const onBlurHandler = (e: React.FocusEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        if (!value) {
            dispatch(setErrorMsg({ ...errorMsg, [name]: "Server output directory name is required!" }));
        }
    };

    return (
        <div className="flex flex-col gap-6">
            <div className="space-y-2">
                <Label>Output Format</Label>
                <RadixSelectControl
                    options={exportDMFormat.map((item) => ({ value: item.value, label: item.text }))}
                    value={scheduledtasks.outputFormat || "FLAT_XML"}
                    placeholder="__placeholder__"
                    onValueChange={selectChangeHandler}
                />
            </div>
            <div>
                <InputField
                    label="Output Directory"
                    name="outputDirectory"
                    value={scheduledtasks?.outputDirectory ?? ""}
                    disabled
                    required
                    onChange={onInputChange}
                    onBlur={onBlurHandler}
                    placeholder="Enter output directory"
                />
            </div>
        </div>
    );
};